import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { getLocale } from './i18n';
import { App } from './App';

// Reflect the resolved UI language on <html> (index.html ships with lang="pt").
// Subsequent switches are handled by setLocale in the i18n store.
document.documentElement.lang = getLocale();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
